<p-toast />
<div class="confirm-dilouge">
  <p-confirmDialog></p-confirmDialog>
</div>

<ngx-ui-loader
  overlayColor="transparent"
  [bgsOpacity]="1"
  fgsType="circle"
  fgsColor="#8B0000"
  pbColor="#8B0000"
  [fgsSize]="50"
  [pbThickness]="1" />
<router-outlet />
